var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 18.75C22.1848 18.75 19.0054 20.067 16.6612 22.4112C14.317 24.7554 13 27.9348 13 31.25V32.5063L50.5 52.7L88 32.5125V31.25C88 27.9348 86.683 24.7554 84.3388 22.4112C81.9946 20.067 78.8152 18.75 75.5 18.75H25.5ZM88 39.6062L51.9813 59C51.526 59.2451 51.017 59.3734 50.5 59.3734C49.983 59.3734 49.474 59.2451 49.0188 59L13 39.6062V68.75C13 72.0652 14.317 75.2446 16.6612 77.5888C19.0054 79.933 22.1848 81.25 25.5 81.25H75.5C78.8152 81.25 81.9946 79.933 84.3388 77.5888C86.683 75.2446 88 72.0652 88 68.75V39.6062Z",
    fill: "#3F3F95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.c7a62f5dcec9bd1662c31d2c07ec003c.svg";
export { ForwardRef as ReactComponent };